import cn from 'classnames';
import { ReactComponent as Oops } from 'assets/images/Oops.svg';

interface IGenericErrorProps {
  className?: string;
  text?: string;
  title?: string;
}

const GenericError = ({ className, text, title }: IGenericErrorProps) => (
  <div
    className={cn(
      'text-center w-100 d-flex flex-column align-items-center',
      className
    )}
  >
    <Oops className="mb-6" />
    <h1 className="mb-4">{title}</h1>
    <h3>{text}</h3>
  </div>
);

GenericError.defaultProps = {
  className: '',
  text: 'Please refresh the page',
  title: 'Oops, something went wrong',
};

export default GenericError;
